<template>
  <h3 class="pb5">Rapport statistique sur le temps consacré (CDX_0145)</h3>
  <CritereRechercheStatistiques :show-nature="false" :show-categorie="false" :show-fonde="false" :show-type="false"
                                ref="critereRechercheStatistiques"/>
  <ButtonBar @fermer="fermer" @imprimer="imprimer"/>
</template>

<script>
import CritereRechercheStatistiques from "@/components/rapports/Rechercher/CritereRechercheStatistiques.vue";
import ButtonBar from "@/components/rapports/Rechercher/ButtonBar.vue";
import axios from "axios";
import {mapGetters} from "vuex";

export default {
  name: "DossiersStatistiqueTempsConsacre",
  components: {CritereRechercheStatistiques, ButtonBar},
  mounted() {
    axios.defaults.headers.common["cleProfil"] = this.profil.cle;
    this.$root.$refs.breadcrumbComp.ajout("Statistiques");
    this.isRechercheDataLoading = true;
    this.$store.dispatch("dossier/rechercherDefaut48HeuresAction")
        .then((res) => {
          this.assignerResultat(res);
          this.isRechercheDataLoading = false;
        });
  },
  computed: {
    ...mapGetters({
      jeton: "cardex/jeton",
      profil: 'cardex/profil',
    }),
  },
  methods: {
    assignerResultat(res) {
      this.$root.$refs.messagesComp.messagesList = res.data.messages;
      this.$refs.critereRechercheStatistiques.assignerListe(res.data.entiteDecision);
    },
    fermer() {
      this.$root.$refs.breadcrumbComp.rediriger();
    },
    imprimer() {
      this.$root.$refs.breadcrumbComp.activeBallBeat = true;
      var criteresRapportVO = this.$refs.critereRechercheStatistiques.getCritereRecherche();
      criteresRapportVO.titre = "DossiersStatistiqueTempsConsacre";
      criteresRapportVO.nomRapport = "statistiques.TempsConsacreGraphiqueStatistiqueDossierGenererRapportSQL_CDX_0145";
      this.$store.dispatch("rapports/obtenirRapportAction",
          criteresRapportVO
      )
          .then(() => {
            this.$root.$refs.breadcrumbComp.activeBallBeat = false;
          });
    }
  },
}
</script>

<style scoped>

</style>